import React, { useState } from "react";
import { Audience } from "../audience-types";

interface AudienceEditorProps {
  onSubmit: (audience: Audience) => void;
  audience?: Audience;
}

const AudienceEditor: React.FC<AudienceEditorProps> = ({
  onSubmit,
  audience: existingAudience,
}) => {
  const initialAudience: Audience = existingAudience
    ? { ...existingAudience }
    : {
        id: generateUniqueID(),
        name: "",
        freeTextDefinition: "",
      };

  const [audience, setAudience] = useState<Audience>(initialAudience);

  const handleMetadataChange = (key: keyof Audience, value: string | Date) => {
    setAudience({ ...audience, [key]: value });
  };

  return (
    <div>
      <div className="mb-4">
        <input
          type="text"
          placeholder="Audience name here"
          id="title"
          value={audience.name}
          onChange={(e) => handleMetadataChange("name", e.target.value)}
          className="bg-slate-600 text-white text-xl w-full sm:w-[800px]"
        />
      </div>
      <div className="mb-4">
        <label className="block mt-8" htmlFor="definition">
          Describe your target audience
        </label>
        <textarea
          id="definition"
          placeholder="Eg, awesome people in Saint-Denis"
          value={audience.freeTextDefinition}
          onChange={(e) =>
            handleMetadataChange("freeTextDefinition", e.target.value)
          }
          rows={4}
          className="bg-slate-600 text-white mt-2 w-full sm:w-[800px]"
        />
      </div>
      <button className="btn-primary" onClick={() => onSubmit(audience)}>
        Save
      </button>
    </div>
  );
};

const generateUniqueID = () => {
  return "audience_" + Math.random().toString(36).substr(2, 9);
};

export default AudienceEditor;
